import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, fileUpload, get } from "../../config";
import { useParams } from "react-router-dom";
import AddContractModal from "../Project/sub-contractors/components/AddContractModal";
import Select from "react-select";
import Spin from "./Spin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faEdit } from "@fortawesome/free-solid-svg-icons";

const ContractEditModal = ({
  id,
  type,
  contractorData,
  contractNumber,
  contractData,
  fetchData,
}) => {
  const params = useParams();
  const projectId = params?.project_id;
  const roleType = localStorage.getItem("roleType");

  const [contractOptions, setContractOptions] = useState(
    roleType === "Contact"
      ? []
      : [{ label: <strong>+ New Contract</strong>, value: "new" }]
  );
  const [contractLoading, setContractLoading] = useState(false);
  const [contract, setContract] = useState();
  const [loading, setLoading] = useState();
  const [addContract, setAddContract] = useState();
  const [newContract, setNewContract] = useState();
  const [showContractEdit, setShowContractEdit] = useState();

  const toggleContractEditModal = () => {
    setShowContractEdit(!showContractEdit);
  };

  const toggleAddModal = () => {
    setAddContract(!addContract);
  };

  const fetchContracts = useCallback(
    async (id) => {
      try {
        setContractLoading(true);
        const { data } = await get(
          `${API.GET_CONTRACTS}?contact_id=${id}&builder_project_id=${projectId}&limit=-1&page=1`
        );
        const list =
          data &&
          data?.data?.data?.length > 0 &&
          data?.data?.data?.map((item) => {
            const list = {
              label: item?.contract_number,
              value: item?.id,
              ...item,
            };
            return list;
          });
        setContractOptions(
          list
            ? roleType === "Contact"
              ? [...list]
              : [
                  ...list,
                  { label: <strong>+ New Contract</strong>, value: "new" },
                ]
            : roleType === "Contact"
            ? []
            : [{ label: <strong>+ New Contract</strong>, value: "new" }]
        );
        setContractLoading(false);
        // const list = data.data;s
        // setContractOptions(list);
        return data.data;
      } catch (error) {
        setContractLoading(false);
        setContractOptions([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    [projectId, roleType]
  );

  useEffect(() => {
    if (showContractEdit) {
      fetchContracts(contractorData?.id);
    }
  }, [contractorData, fetchContracts, showContractEdit]);

  useEffect(() => {
    if (newContract) {
      let newContractData = contractOptions?.find(
        (item) => item.value === newContract?.id
      );
      setContract(newContractData);
    }
  }, [contractOptions, newContract]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append(
        "contract_id",
        contract ? contract?.id : contractData ? contractData?.id : ""
      );
      // formData.append("id", id);
      formData.append("_method", "put");
      formData.append(
        "module",
        type === "paymentSchedule"
          ? "payment_schedule"
          : type === "paymentClaim"
          ? "payment_claim"
          : type === "payment"
          ? "payment"
          : "receipt"
      );
      const response = await fileUpload(
        `${API.RECORD_CONTRACT_UPDATE}/${id}`,
        formData,
        {}
      );
      if (response.status === 200) {
        toast.success(response?.data?.message);
        toggleContractEditModal();
        setNewContract();
        setAddContract();
        setContract();
        fetchData();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
      } else {
        toast.error(error?.message);
      }
    }
  };

  return (
    <>
      <div
        onClick={() => toggleContractEditModal()}
        style={{
          cursor: "pointer",
          width: "fit-content",
        }}
      >
        {contractNumber ? (
          <span className="contract-edit-number">
            {contractNumber} <FontAwesomeIcon icon={faEdit} />
          </span>
        ) : (
          <Button className="contract-edit-modal-add">
            <FontAwesomeIcon icon={faAdd} />
          </Button>
        )}
      </div>
      {showContractEdit && (
        <Modal
          size="lg"
          show={showContractEdit}
          onHide={toggleContractEditModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Update Contract
          </Modal.Header>
          <Modal.Body>
            {loading && <Spin />}
            <div className="modal-body">
              <div className="payment-schedule-header-item contract-number-edit-body">
                <div>
                  <p>Contract/Agreement Number</p>
                  <Select
                    options={contractOptions}
                    onChange={(e) => {
                      if (e?.value === "new") {
                        setAddContract(true);
                      } else {
                        setAddContract(false);
                        setNewContract("");
                        setContract(e);
                      }
                    }}
                    value={
                      contract
                        ? contractOptions?.find(
                            (item) => item.value === contract?.value
                          )
                        : contractData
                        ? contractOptions?.find(
                            (item) => item.value === contractData?.id
                          )
                        : ""
                    }
                    isLoading={contractLoading}
                    placeholder="Select Contract"
                    name="contract"
                    classNamePrefix="selectbox"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="Button"
                className="btn btn-secondary"
                onClick={() => {
                  toggleContractEditModal();
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="btn btn-primary"
                data-dismiss="modal"
                disabled={!type}
                onClick={() => {
                  handleSubmit();
                }}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {addContract && (
        <AddContractModal
          contractor={contractorData}
          toggleAddModal={toggleAddModal}
          handleAdd={() => {
            fetchContracts(contractorData?.id);
          }}
          showAdd={addContract}
          setNewContract={setNewContract}
        />
      )}
    </>
  );
};

export default ContractEditModal;
